import type { MenuItemType } from '@rfc/rfc-components-library/types'
import { ADMIN_STATS_ROUTE_NAME, EAdminEventsRoutesValues } from './admin/AdminRoutesEnum'
import { ADMIN_EVENTS_ROUTES, ADMIN_STATS_ROUTE, EVENTS_ROUTE } from './routes'
import { ECheckpointRoutesNamesValues } from './routing/checkpointsRoutes'
import { EEventRoutesNamesValues } from './routing/eventsRoutes'

export const menuRoutesTop: MenuItemType[] = [
    {
        icon: 'calendar-days',
        label: 'menu.events',
        to: EVENTS_ROUTE,
        permissions: true /* !!store.value?.state.authentication.me.organization_id &&
            userHasPermission(EEventsPerm.EVENTS_VIEW) */,
        names: [...EEventRoutesNamesValues, ...ECheckpointRoutesNamesValues]
    }
    /* {
        icon: 'calendar-days',
        label: 'menu.support',
        to: SUPPORTFAQ_ROUTE,
        permissions: true !!store.value?.state.authentication.me.organization_id &&
            userHasPermission(EEventsPerm.EVENTS_VIEW),
        names: ESupportFaqRoutesValues
    } */
]

export const menuAdminView: MenuItemType[] = [
    {
        label: 'menu.events',
        names: EAdminEventsRoutesValues,
        to: ADMIN_EVENTS_ROUTES.baseUrl,
        permissions: true
    },
    {
        label: 'menu.stats',
        names: [ADMIN_STATS_ROUTE_NAME],
        to: ADMIN_STATS_ROUTE,
        permissions: true
    }
]
